function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M33.751 0C34.112 0.449044 34.5761 0.845259 34.8339 1.32072C37.5154 6.36585 40.1712 11.4374 42.8527 16.4825C43.7035 18.0674 43.6004 19.4938 42.4659 20.9466C39.3203 25.0144 36.2005 29.1086 33.0806 33.1764C32.9259 33.3613 32.797 33.5726 32.6165 33.7311C32.075 34.2594 31.4047 34.2594 30.889 33.7047C30.6827 33.467 30.5022 33.1764 30.3475 32.9123C27.6402 27.8143 24.9329 22.7163 22.2514 17.5919C21.4521 16.0863 21.5295 14.66 22.5866 13.2864C25.758 9.2186 28.8779 5.09797 32.0235 1.00374C32.3071 0.633944 32.6939 0.343386 33.029 0C33.2611 0 33.5189 0 33.751 0Z",
  fill: "#1191D0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 16.7467C0.335189 16.192 0.825082 16.0071 1.46968 16.0071C6.96163 16.0071 12.4278 16.0071 17.9197 15.9807C19.4926 15.9807 20.6528 16.7203 21.4006 18.1466C24.1079 23.3503 26.7894 28.5539 29.4709 33.7575C29.5482 33.8896 29.6256 34.0481 29.6772 34.2066C30.0639 35.2103 29.5998 35.9235 28.5427 35.9499C26.9699 35.9763 25.3971 35.9763 23.8242 35.9763C19.9051 35.9763 15.986 35.9763 12.0926 36.0291C10.3651 36.0291 9.15325 35.2631 8.35395 33.7311C5.59509 28.3426 2.83622 23.0069 0.0773514 17.6712C0.0515676 17.6448 0.0257838 17.6184 0 17.5919C0 17.3014 0 17.0108 0 16.7467Z",
  fill: "#83B441"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.342 56.8172C29.1099 56.5002 28.8521 56.1833 28.6716 55.8399C27.1246 52.9343 25.6033 50.0023 24.0563 47.0967C23.5148 46.0666 23.5664 45.1685 24.2884 44.244C26.1448 41.8667 27.9754 39.463 29.8061 37.0593C30.4249 36.2405 30.9406 36.2669 31.4305 37.1914C33.0548 40.2554 34.6792 43.3459 36.3036 46.41C36.7419 47.2552 36.7161 48.0741 36.1231 48.8665C34.2409 51.323 32.3587 53.7796 30.4507 56.2625C30.296 56.4738 30.1155 56.6587 29.935 56.8436C29.7287 56.8172 29.5225 56.8172 29.342 56.8172Z",
  fill: "#1191D0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1161 47.2817C42.5433 47.2817 40.9705 47.2552 39.4234 47.2817C38.3921 47.3081 37.6701 46.8326 37.206 45.9345C35.6074 42.8969 34.0088 39.8592 32.4102 36.8216C31.9203 35.8971 32.1782 35.448 33.2095 35.4216C36.3294 35.3952 39.4492 35.3688 42.5691 35.316C43.7035 35.2895 44.5028 35.765 45.0185 36.7952C46.5655 39.78 48.1384 42.7384 49.7112 45.6968C49.7627 45.776 49.8143 45.8817 49.8401 45.9609C50.2011 46.7005 49.9432 47.1496 49.1439 47.176C47.468 47.2024 45.8178 47.176 44.1419 47.176C44.1161 47.2288 44.1161 47.2552 44.1161 47.2817Z",
  fill: "#83B441"
});

const SvgAf = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  viewBox: "0 0 50 57",
  fill: "none",
  style: {
    enableBackground: "new 0 0 53 50.5"
  },
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/af.fc2fd29f.svg";
export { ForwardRef as ReactComponent };